// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.peopleMainDiv {
    width: 100%;
    overflow-x: hidden;
}

.pageNumberDivPeople {
    background-color: rgb(248 248 250);
    width: -moz-fit-content;
    width: fit-content;
    height: 30px    ;
    border-radius: 27.5px;
    padding: 15px;
    margin-top: 20px;
}

.headerDiv {
    display: flex;
    position: fixed;
}

.headerDivReview {
    display: flex;
}

.pageNumberSpanPeople {
  font-family: Gilory-Semi;
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  font-weight: 800;
  padding-right: 10px;
  cursor: pointer;
}

.tabDetailsPeople {
    width: 100%;
    height: 100%;
    margin-top: 20px;
}

.marginLeft250px {
    margin-left: 250px;
}

.marginLeft20 {
    margin-left: 20px;
}

.selectedSpan{
    color: #767676;
}

.unSelectedSpan {
    color: rgb(215 215 215);
    cursor: pointer;
}

.profileInfoBasicData {
    margin-top: 7%;
    position: fixed;
    margin-left: 17.5%;
}

.profileInfoBasicDataIpad {
    margin-top: 7%;
    position: fixed;
    margin-left: 5%;
    margin-top: 8%;
}

.profileInfoSpan {
    font-size: 20px;
    font-family:Gilory-Semi;
    color: rgb(127 127 127);
}

.profileNameInput {
    width: auto;
    height: 40px;
    border-radius: 13px;
    border: solid 1px #d7d7d7;
    font-family:Gilory-Semi;
    font-size: 18px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #9b9b9b;
    padding-left:20px; 
}

.imageContainerPeople {
    display: flex;
    width: 100%;
    margin-top: 11%;
    margin-left: 250px;
    position: fixed;
}

.imageContainerPeopleIpad {
    display: flex;
    width: 100%;
    margin-top: 14%;
    margin-left: 5%;
    position: fixed;
}

.dragAndDropPeople {
    width: 250px;
    height: 250px;
    margin-right: 20px;
}

.hrStyles {
    border: 1px solid;
    color: rgb(239 239 239);
}

.selfieDiv{
    position: fixed;
    margin-top: 31%;
    margin-left: 17.5%;
    margin-right: 17.5%;
}

/* .selfieContainer{
    display: flex;
    align-items: center;
} */

.selfieDivIpad{
    position: fixed;
    margin-top: 40%;
    margin-left: 5%;
}

.selfieImage{
    width: 243px;
    height: 243px;
    border-radius: 13px;
}

.selfieImageIpad{
    width: 200px;
    height: 200px;
    border-radius: 13px;
}

.pprButtonDiv{
    position: fixed;
    margin-left: 20%;
    margin-top: 48%;
}

.pprButtonDivIpad{
    position: fixed;
    margin-left: 15%;
    margin-top: 57%;
}

.likeButtonActiveStyle {
    color: white; 
    margin-right: 20px;
    margin-left: 20px; 
    background-color: green
}

.likeButtonInActiveStyle {
    color: green; 
    margin-right: 20px;
    margin-left: 20px; 
    background-color: white
}

.passButtonActiveStyle {
    cursor: pointer;
    color: white;
    margin-right: 20px;
    margin-left: 20px;
    background-color: red;
}

.passButtonInActiveStyle {
    cursor: pointer;
    color: red;
    margin-right: 20px;
    margin-left: 20px;
    background-color: white;
}

.inappButtonActiveStyle {
    cursor: pointer;
    color: white;
    margin-right: 20px;
    margin-left: 20px;
    background-color: rgb(70 70 70);
}

.inappButtonInActiveStyle {
    cursor: pointer;
    color: rgb(70 70 70);
    margin-right: 20px;
    margin-left: 20px;
    background-color: white;
}

.recheckSpanDetails {
    font-family: 'Gilory-Semi';
    font-size: 16px;
    color: #eb5252;
}

.feedCuratorSpanDetails {
    color: #4f8f5f;
}

.recheckSpanDiv {
    display: flex;
    flex-direction: row;
    gap: 18px;
    align-items: center;
    margin-top: 6%;
    position: fixed;
    margin-left: 50%;
}

.deviceType{
    margin-top: 60px;
}

.checkboxDivIpad {
    margin-top: 55%;
    margin-right: 5%;
}

.checkBoxPeopleIpad {
    width: 20px;
    height: 20px;
}

.feedbackIconWrapper{
    display: flex;
    justify-content: center;    
    align-items: center;
    background: #F1F1F1;
    border-radius: 20%;
    cursor: pointer;
    margin-top: 2px;
} 

.feedbackIcon {
    padding: 5px;
}

.feedbackSelected {
    background-color: #FFBBA5;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/People.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,uBAAkB;IAAlB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,eAAe;IACf,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;;GAGG;;AAEH;IACI,eAAe;IACf,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".peopleMainDiv {\n    width: 100%;\n    overflow-x: hidden;\n}\n\n.pageNumberDivPeople {\n    background-color: rgb(248 248 250);\n    width: fit-content;\n    height: 30px    ;\n    border-radius: 27.5px;\n    padding: 15px;\n    margin-top: 20px;\n}\n\n.headerDiv {\n    display: flex;\n    position: fixed;\n}\n\n.headerDivReview {\n    display: flex;\n}\n\n.pageNumberSpanPeople {\n  font-family: Gilory-Semi;\n  font-size: 20px;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  font-weight: 800;\n  padding-right: 10px;\n  cursor: pointer;\n}\n\n.tabDetailsPeople {\n    width: 100%;\n    height: 100%;\n    margin-top: 20px;\n}\n\n.marginLeft250px {\n    margin-left: 250px;\n}\n\n.marginLeft20 {\n    margin-left: 20px;\n}\n\n.selectedSpan{\n    color: #767676;\n}\n\n.unSelectedSpan {\n    color: rgb(215 215 215);\n    cursor: pointer;\n}\n\n.profileInfoBasicData {\n    margin-top: 7%;\n    position: fixed;\n    margin-left: 17.5%;\n}\n\n.profileInfoBasicDataIpad {\n    margin-top: 7%;\n    position: fixed;\n    margin-left: 5%;\n    margin-top: 8%;\n}\n\n.profileInfoSpan {\n    font-size: 20px;\n    font-family:Gilory-Semi;\n    color: rgb(127 127 127);\n}\n\n.profileNameInput {\n    width: auto;\n    height: 40px;\n    border-radius: 13px;\n    border: solid 1px #d7d7d7;\n    font-family:Gilory-Semi;\n    font-size: 18px;\n    font-weight: 600;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    color: #9b9b9b;\n    padding-left:20px; \n}\n\n.imageContainerPeople {\n    display: flex;\n    width: 100%;\n    margin-top: 11%;\n    margin-left: 250px;\n    position: fixed;\n}\n\n.imageContainerPeopleIpad {\n    display: flex;\n    width: 100%;\n    margin-top: 14%;\n    margin-left: 5%;\n    position: fixed;\n}\n\n.dragAndDropPeople {\n    width: 250px;\n    height: 250px;\n    margin-right: 20px;\n}\n\n.hrStyles {\n    border: 1px solid;\n    color: rgb(239 239 239);\n}\n\n.selfieDiv{\n    position: fixed;\n    margin-top: 31%;\n    margin-left: 17.5%;\n    margin-right: 17.5%;\n}\n\n/* .selfieContainer{\n    display: flex;\n    align-items: center;\n} */\n\n.selfieDivIpad{\n    position: fixed;\n    margin-top: 40%;\n    margin-left: 5%;\n}\n\n.selfieImage{\n    width: 243px;\n    height: 243px;\n    border-radius: 13px;\n}\n\n.selfieImageIpad{\n    width: 200px;\n    height: 200px;\n    border-radius: 13px;\n}\n\n.pprButtonDiv{\n    position: fixed;\n    margin-left: 20%;\n    margin-top: 48%;\n}\n\n.pprButtonDivIpad{\n    position: fixed;\n    margin-left: 15%;\n    margin-top: 57%;\n}\n\n.likeButtonActiveStyle {\n    color: white; \n    margin-right: 20px;\n    margin-left: 20px; \n    background-color: green\n}\n\n.likeButtonInActiveStyle {\n    color: green; \n    margin-right: 20px;\n    margin-left: 20px; \n    background-color: white\n}\n\n.passButtonActiveStyle {\n    cursor: pointer;\n    color: white;\n    margin-right: 20px;\n    margin-left: 20px;\n    background-color: red;\n}\n\n.passButtonInActiveStyle {\n    cursor: pointer;\n    color: red;\n    margin-right: 20px;\n    margin-left: 20px;\n    background-color: white;\n}\n\n.inappButtonActiveStyle {\n    cursor: pointer;\n    color: white;\n    margin-right: 20px;\n    margin-left: 20px;\n    background-color: rgb(70 70 70);\n}\n\n.inappButtonInActiveStyle {\n    cursor: pointer;\n    color: rgb(70 70 70);\n    margin-right: 20px;\n    margin-left: 20px;\n    background-color: white;\n}\n\n.recheckSpanDetails {\n    font-family: 'Gilory-Semi';\n    font-size: 16px;\n    color: #eb5252;\n}\n\n.feedCuratorSpanDetails {\n    color: #4f8f5f;\n}\n\n.recheckSpanDiv {\n    display: flex;\n    flex-direction: row;\n    gap: 18px;\n    align-items: center;\n    margin-top: 6%;\n    position: fixed;\n    margin-left: 50%;\n}\n\n.deviceType{\n    margin-top: 60px;\n}\n\n.checkboxDivIpad {\n    margin-top: 55%;\n    margin-right: 5%;\n}\n\n.checkBoxPeopleIpad {\n    width: 20px;\n    height: 20px;\n}\n\n.feedbackIconWrapper{\n    display: flex;\n    justify-content: center;    \n    align-items: center;\n    background: #F1F1F1;\n    border-radius: 20%;\n    cursor: pointer;\n    margin-top: 2px;\n} \n\n.feedbackIcon {\n    padding: 5px;\n}\n\n.feedbackSelected {\n    background-color: #FFBBA5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
